import React, { useEffect } from "react";
import { useJwt } from "react-jwt";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import SessionExpiredModal from "./Components/NewUI/Common/SessionExpiredModal";
import { SessionProvider, useSession } from "./context/SessionContext";
import { Routes } from "./routes";
import { trackPageView } from "./utils/metaPixel";

function AppContent(props) {
  const token = props?.user?.token;
  const { isExpired } = useJwt(token);
  const { isSessionExpired, handleLoginAgain } = useSession();
  const location = useLocation();

  // Lazy load semantic-ui CSS to avoid render blocking
  useEffect(() => {
    import("semantic-ui-css/semantic.min.css");
  }, []);

  useEffect(() => {
    trackPageView();
  }, [location.pathname]);

  if (token) {
    if (isExpired) {
      localStorage.removeItem("gpay_token");
      window.location.href = "/";
      localStorage.removeItem("gpay_token");
    }
  }

  return (
    <>
      <Routes />
      <SessionExpiredModal
        isOpen={isSessionExpired}
        onLoginAgain={handleLoginAgain}
      />
    </>
  );
}

function App(props) {
  return (
    <SessionProvider>
      <AppContent {...props} />
    </SessionProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail.user_detail,
  };
};
export default connect(mapStateToProps)(App);
